var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar__container"},[_c('div',{staticClass:"progress-bar__wrapper"},[_c('div',{staticClass:"progress-bar__progress",style:({ width: `${_setup.progressAmount}%` })})]),_vm._v(" "),_c('span',{staticClass:"progress-bar__title"},[_vm._v(_vm._s(_vm.$t('upsell.remaining', {
      amount: _vm.$n(_setup.remainingAmount, {
        style: 'currency',
        currency: _setup.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }),
    })))])])
}
var staticRenderFns = []

export { render, staticRenderFns }